import React from "react";

import {
  Section,
  TitleH1,
} from "../../styles/sharedStyles";
import {
  Container,
  Divider,
  LDash,
  MainText,
  Ul
} from "../Policy/styles";

export const Consent = () => {
  return (
    <Section>
      <Container>
        <TitleH1>СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ</TitleH1>
        <MainText>
          Принимая условия Политики в отношении обработки персональных данных, размещенной на сайте https://prohorovaconsult.com/policy, я даю свое согласие Индивидуальному предпринимателю <strong>Прохоровой Любови Васильевне</strong> (ИНН 231130103902, ОГРНИП 321237500416095), на обработку персональных данных на основании Федерального закона «О персональных данных» от 27 июля 2006 года № 152-ФЗ.
        </MainText>
        <Divider />
        <MainText>
          Я уведомлен, что Оператор осуществляет обработку персональных данных Субъектов персональных данных, в соответствии с целями такой обработки, которые перечислены в разделе 3 Политики в отношении обработки персональных данных, т.е. совершает действия с персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, обезличивание, блокирование, удаление, уничтожение персональных данных.
        </MainText>
        <Divider />
        <MainText>
          Я ознакомлен с Политикой путём личного прочтения при посещении сайта: https://prohorovaconsult.com/policy, и выражаю настоящее Согласие – путём самостоятельного волеизъявления (проставление «галочки» / нажатие на соответствующую «кнопку» на Сайте или иным способом), что являет собой ckick-wrap соглашение.
        </MainText>
        <Divider />
        <MainText>
          Я знаю, что Оператор обрабатывает персональные данные Пользователя только в случае их заполнения и(или) отправки Пользователем самостоятельно через специальные формы, расположенные на сайте, ином ресурсе Оператора, либо самостоятельного внесения Пользователем в документ, далее направляемый Оператору в порядке электронной коммуникации.<br/>
          К обрабатываемым персональным данным Субъектов персональных данных в соответствии с Политикой относятся (далее – «Сведения»): имя, фамилия, отчество; дата рождения; данные паспорта или иного документа, удостоверяющего личность; адрес регистрации; адрес электронной почты; номер телефона; банковские реквизиты. Оператор не обрабатывает персональные данные, относящиеся к специальным категориям персональных данных.
        </MainText>
        <Divider />
        <MainText>
          Кроме того, я ознакомлен с целями сбора персональных данных Субъектов персональных данных:
          <Ul>
            <LDash>обеспечение соблюдения Конституции, федеральных законов и иных нормативных правовых актов Российской Федерации;</LDash>
            <LDash>заключение и исполнение договора (в том числе – в формате оферты на сайте Оператора https://prohorovaconsult.com/);</LDash>
            <LDash> установление Оператором с Субъектом персональных данных обратной связи, в том числе направление уведомлений, запросов, касающихся использования Сайта, оказания услуг;</LDash>
            <LDash> идентификация субъекта персональных данных;</LDash>
            <LDash> информирование Пользователя посредством отправки электронных писем или сообщений (в том числе, мессенджере) о факте и ходе оказания услуг.</LDash>
          </Ul>
          Персональные данные могут быть использованы для иных целей, в случае, если они являются обязательными согласно законодательству Российской Федерации.
        </MainText>
        <Divider />
        <MainText>
          Обработка персональных данных начинается с момента получения Оператором персональных данных, а именно: с момента заполнения заявки на Сайте. Проставляя галочку в чек-боксе и нажимая кнопку «Оплатить», «Заказать», «Связаться», «Выбрать» и т.п., Пользователь (в зависимости от целей) дает Согласие на обработку персональных данных и(или) Согласие на рассылку электронных сообщений.<br/>
          Для персональных данных, которые автоматически передаются Оператору в процессе использования Сайта с помощью установленного на устройстве Пользователя программного обеспечения (cookies), Пользователь считается предоставившим согласие на обработку своих персональных данных в момент начала использования Сайта.
        </MainText>
        <Divider />
        <MainText>
          Любая информация, которая передана Оператору в устной или письменной форме посредством информационной-телекоммуникационной сети «Интернет» либо иным способом, считается конфиденциальной.
        </MainText>
        <Divider />
        <MainText>
          Оператором обеспечивается сохранность полученных персональных данных Субъектов персональных данных, за исключением добровольного предоставления Субъектом персональных данных информации о себе для общего доступа неограниченному кругу лиц.
        </MainText>
        <Divider />
        <MainText>
          Я уведомлен(-а), что в случае выявления неточностей в персональных данных, я могу актуализировать их самостоятельно, путем направления Оператору уведомление на адрес электронной почты Оператора: prohorovaconsult@yandex.ru с пометкой «Актуализация персональных данных», либо (в случае, если такая возможность предусмотрена) – самостоятельно в личном кабинете Пользователя на сайта (в приложении / на платформе) Оператора.
        </MainText>
        <Divider />
        <MainText>
          Срок обработки персональных данных обусловлен целями обработки, но не может превышать сроков, установленных законодательством Российской Федерации.
        </MainText>
        <Divider />
        <MainText>
          <strong>
            Я могу в любой момент отозвать свое согласие на обработку персональных данных, направив Оператору уведомление посредством электронной почты на электронный адрес Оператора: prohorovaconsult@yandex.ru с пометкой «Отзыв согласия на обработку персональных данных».
          </strong>
        </MainText>
        <Divider />
        <MainText>
          Я подтверждаю, что действую по своей воле и в своём интересе. Данное Согласие является конкретным, информированным и сознательным.
        </MainText>
      </Container>

    </Section>
  );
};

